import { useTranslation } from "react-i18next";
import { getColor } from "../../../../seoAnalyzer/helper";

export const MetaAnalysis = ({ analysis }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Score Bar */}
      <div
        className={`text-end ps-3 text-transparent bg-gradient-to-r pe-8 bg-clip-text ${getColor(
          analysis?.total_score
        )} mt-3`}
        style={{ width: `${analysis?.total_score}%` }}
      >
        {analysis?.total_score}%
      </div>
      <div className="w-full relative p-3 rounded-xl bg-Lightwhite">
        <div
          className={`bg-gradient-to-r ${getColor(
            analysis?.total_score
          )} h-full  rounded-xl  absolute top-0 left-0`}
          style={{ width: `${analysis?.total_score}%` }}
        ></div>
      </div>

      {/* Meta Title Keyword Inclusion */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Meta-Title-Keyword-Inclusion", "Metatitle: Keyword Inclusion ")}{" "}
        </p>
        <p
          className={`${
            analysis?.metaTitle_keyword?.score == 100
              ? "text-green-500"
              : analysis?.metaTitle_keyword?.score === 50
              ? "text-yellow-400"
              : analysis?.metaTitle_keyword?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.metaTitle_keyword?.score === 100 && (
            <>
              {t(
                "The-target-request-fully-appears-in-the-meta-title.That’s-perfect!",
                "The target request fully appears in the meta title.That’s-perfect!"
              )}
            </>
          )}

          {analysis?.metaTitle_keyword?.score === 50 && (
            <>
              {t(
                "The-target-request-partially-appears-in-the-meta-title.Try-to-add-the-rest!",
                "The target request partially appears in the meta title. Try to add the rest!"
              )}
            </>
          )}

          {analysis?.metaTitle_keyword?.score === 0 && (
            <>
              {t(
                "The-target-request-does-not-appear-in-the-meta-title.Add-it!",
                "The target request does not appear in the meta title. Add it!"
              )}
            </>
          )}
          {analysis?.metaTitle_keyword?.score === -1 && (
            <>{t("Please-add-meta-title", "Please add meta title")}</>
          )}
        </p>
      </div>

      {/* Meta Title Length */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Meta-Title-Length", "Metatitle: Length")}{" "}
        </p>
        <p
          className={`${
            analysis?.metaTitle_length?.score == 100
              ? "text-green-500"
              : analysis?.metaTitle_length?.score === 50
              ? "text-yellow-400"
              : analysis?.metaTitle_length?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.metaTitle_length?.score === 100 && (
            <>
              {`${t(
                "The-meta-title-has-a-good-size",
                "The meta title is a good size"
              )} ${
                analysis?.metaTitle_length.chars < 30
                  ? t("short", "short")
                  : t("long", "long")
              } 
                                   (${analysis?.metaTitle_length.chars} ${t(
                "character",
                "character"
              )}${analysis?.metaTitle_length.chars > 1 ? "s" : ""} 
                                   ${t("for", "for")} ${
                analysis?.metaTitle_length.words
              } ${t("word", "word")}${
                analysis?.metaTitle_length.words > 1 ? "s" : ""
              }).`}
            </>
          )}
          {analysis?.metaTitle_length?.score === 50 && (
            <>
              {`${t("The-meta-title-is-a-bit", "The meta title is a bit")} ${
                analysis?.metaTitle_length.chars < 30
                  ? t("short", "short")
                  : t("long", "long")
              } 
                                   (${analysis?.metaTitle_length.chars} ${t(
                "character",
                "character"
              )}${analysis?.metaTitle_length.chars > 1 ? "s" : ""} 
                                   ${t("for", "for")} ${
                analysis?.metaTitle_length.words
              } ${t("word", "word")}${
                analysis?.metaTitle_length.words > 1 ? "s" : ""
              }).`}
            </>
          )}
          {analysis?.metaTitle_length?.score === 0 && (
            <>
              {`${t("The-meta-title-is-too", "The meta title is too")} ${
                analysis?.metaTitle_length.chars < 30
                  ? t("short", "short")
                  : t("long", "long")
              } 
                                   (${analysis?.metaTitle_length.chars} ${t(
                "character",
                "character"
              )}${analysis?.metaTitle_length.chars > 1 ? "s" : ""} 
                                   ${t("for", "for")} ${
                analysis?.metaTitle_length.words
              } ${t("word", "word")}${
                analysis?.metaTitle_length.words > 1 ? "s" : ""
              }).`}
            </>
          )}
          {analysis?.metaTitle_length?.score === -1 && (
            <>{t("Please-add-meta-title", "Please add meta title")}</>
          )}
        </p>
      </div>

      {/* Meta title and H1 Differentiation */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t(
            "Meta-Title-and-H1-Differentiation",
            "Meta Title and H1 Differentiation"
          )}{" "}
        </p>
        <p
          className={`${
            analysis?.metaTitle_difference?.score == 100
              ? "text-green-500"
              : analysis?.metaTitle_difference?.score === 50
              ? "text-yellow-400"
              : analysis?.metaTitle_difference?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.metaTitle_difference?.score == 100 && (
            <>
              {`${t("The-meta-title-contains", "The meta title contains")} ${
                analysis?.metaTitle_difference.missingWords
              }
                                   ${t(
                                     "keyword(s)-that-are-not-included-in-the-h1-title",
                                     "keyword(s) that are not included in the h1 title."
                                   )}`}
            </>
          )}{" "}
          {analysis?.metaTitle_difference?.score == 50 && (
            <>
              {`${t("The-meta-title-contains", "The meta title contains")} ${
                analysis?.metaTitle_difference.missingWords
              } ${t(
                "keyword(s)-that-are-not-included-in-the-h1-title",
                "keyword(s) that are not included in the h1 title."
              )}`}
            </>
          )}{" "}
          {analysis?.metaTitle_difference?.score == 0 && (
            <>
              {t(
                "The-meta-title-and-h1-title-are-100-percents-similar",
                "The meta title and h1 title are 100% similar."
              )}
            </>
          )}{" "}
          {analysis?.metaTitle_difference?.score == -1 && (
            <>{t("Please-add-meta-title", "Please add meta title")}</>
          )}
        </p>
      </div>

      {/* Meta Description Target Keyword Inclusion */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t(
            "Meta-Description-Target-Keyword-Inclusion",
            "Meta Description: Target Keyword Inclusion"
          )}{" "}
        </p>
        <p
          className={`${
            analysis?.metaDescription_keyword?.score == 100
              ? "text-green-500"
              : analysis?.metaDescription_keyword?.score === 50
              ? "text-yellow-400"
              : analysis?.metaDescription_keyword?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.metaDescription_keyword?.score === 100 && (
            <>
              {t(
                "The-target-request-fully-appears-in-the-meta-title.That’s-perfect!",
                "The target request fully appears in the meta title. That’s perfect!"
              )}
            </>
          )}{" "}
          {analysis?.metaDescription_keyword?.score === 50 && (
            <>
              {t(
                "The-target-request-partially-appears-in-the-meta-title.Try-to-add-the-rest!",
                "The target request partially appears in the meta title. Try to add the rest!"
              )}
            </>
          )}{" "}
          {analysis?.metaDescription_keyword?.score === 0 && (
            <>
              {t(
                "The-target-request-does-not-appear-in-the-meta-title.Add-it!",
                "The target request does not appear in the meta title. Add it!"
              )}
            </>
          )}{" "}
          {analysis?.metaDescription_keyword?.score === -1 && (
            <>
              {t("Please-add-meta-description", "Please add meta description")}
            </>
          )}
        </p>
      </div>

      {/* Meta Description Length Check */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Meta-Description:Length", "Meta Description: Length")}{" "}
        </p>
        <p
          className={`${
            analysis?.metaDescription_length?.score == 100
              ? "text-green-500"
              : analysis?.metaDescription_length?.score === 50
              ? "text-yellow-400"
              : analysis?.metaDescription_length?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.metaDescription_length?.score === 100 && (
            <>
              {`${t(
                "The-meta-description-has-a-good-size",
                "The meta description has a good size"
              )} 
                                   (${analysis?.metaDescription_length.chars}
                                   ${t("character", "character")}${
                analysis?.metaDescription_length.chars > 1 ? "s" : ""
              } ${t("for", "for")}
                                    ${
                                      analysis?.metaDescription_length.words
                                    } ${t("word", "word")}${
                analysis?.metaDescription_length.words > 1 ? "s" : ""
              }).`}
            </>
          )}

          {analysis?.metaDescription_length?.score == 50 && (
            <>
              {`${t(
                "The-meta-description-is-a-bit",
                "The meta description is a bit"
              )} ${
                analysis?.metaDescription_length.chars >= 80 &&
                analysis?.metaDescription_length.chars <= 119
                  ? "short"
                  : "long"
              } 
                                   (${analysis?.metaDescription_length.chars}
                                   ${t("character", "character")}${
                analysis?.metaDescription_length.chars > 1 ? "s" : ""
              } ${t("for", "for")}
                                    ${
                                      analysis?.metaDescription_length.words
                                    } ${t("word", "word")}${
                analysis?.metaDescription_length.words > 1 ? "s" : ""
              }).`}
            </>
          )}

          {analysis?.metaDescription_length?.score === 0 && (
            <>
              {`${t(
                "The-meta-description-is-too",
                "The meta description is too"
              )} ${
                analysis?.metaDescription_length.chars < 80 ? "short" : "long"
              } 
                                   (${analysis?.metaDescription_length.chars}
                                   ${t("character", "character")}${
                analysis?.metaDescription_length.chars > 1 ? "s" : ""
              } ${t("for", "for")}
                                    ${
                                      analysis?.metaDescription_length.words
                                    } ${t("word", "word")}${
                analysis?.metaDescription_length.words > 1 ? "s" : ""
              }).`}
            </>
          )}
          {analysis?.metaDescription_length?.score === -1 && (
            <>
              {t("Please-add-meta-description", "Please add meta description")}
            </>
          )}
        </p>
      </div>
    </>
  );
};
